import { render, staticRenderFns } from "./AuthTokenSection.vue?vue&type=template&id=a5708d5e"
import script from "./AuthTokenSection.vue?vue&type=script&lang=ts"
export * from "./AuthTokenSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports